export const Facebook = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.5255 15.338H23.1316V11.8004C23.1316 10.4718 24.0121 10.1621 24.6323 10.1621C25.2511 10.1621 28.4388 10.1621 28.4388 10.1621V4.32149L23.1965 4.30103C17.3771 4.30103 16.0528 8.65712 16.0528 11.4448V15.338H12.6873V21.3564H16.0528C16.0528 29.0801 16.0528 38.3864 16.0528 38.3864H23.1316C23.1316 38.3864 23.1316 28.9884 23.1316 21.3564H27.9082L28.5255 15.338Z"
        fill="hsl(var(--fc1), 50%)"
      />
    </svg>
  );
};
